const darkMode = false;

export const colors = {
  colorBasicBackground: darkMode ? "#141414" : "#ffffff", //DARKMODE
  colorLightBackground: darkMode ? "#2C2C2C" : "#fbfbfb", //"#ffffff", //DARKMODE
  colorBackgroundLight: darkMode ? "#2C2C2C" : "#ffffff", //"#EBEDEF", //DARKMODE
  colorCardBackground: darkMode ? "#141414" : "#ffffff", //DARKMODE
  colorMainText: darkMode ? "#DCDCDC" : "#2B2A35", //DARKMODE
  colorNameText: "#2969B0",
  headerBackgroundColor: "#FBFBFB", //darkMode ? "#141414" : "#ffffff", //DARKMODE
  headerTextColor: darkMode ? "#DCDCDC" : "#2D3F4F", //DARKMODE

  colorPrimary: "#1490DF",
  colorPrimaryBlue: "#1990FF",
  colorSystemBlue: "#1777FF",
  colorSecondary: "#FF602F",
  colorPositive: "#5ec198",
  colorNegative: "#ff5757",
  colorNavigation: "#F9F9F9",
  colorSystemPrimary: "#1890FF",
  colorMainMenu: "#fbfbfb",
  colorAccent: "#4A95DD", //"#5f9eea",
  colorMainSubText: "#939DA8",
  colorTooltip: null, //"#FF602F", //"#5F9EEB";
  colorTooltipSecondary: "#2B2A35",
  colorGreyText: "#AAAAAA",
  colorDescriptionGreyText: "#D4D4D4",
  colorLightGreyText: "lightgrey",
  colorVeryLightGreyText: "#E8E8E8",
  colorLinks: "#1890FF",
  colorBackgroundDark: "#3A3E48",
  colorSettings: "#f5f5f5",
  colorChanges: "#FFD6CA",
  colorAction: "#468FAF",
  colorMenuTree: "#313131",
  headerLogoBackground: "transparent", //"#253342",

  heatmapColors: [
    { count: 1, color: "#a9d6e5" },
    { count: 3, color: "#89c2d9" },
    { count: 2, color: "#61a5c2" },
    { count: 5, color: "#468faf" },
    { count: 9, color: "#2c7da0" },
    { count: 20, color: "#2a6f97" },
    { count: 30, color: "#014f86" },
  ],

  // colorKanban: [
  //   "#a9d6e5",
  //   "#89c2d9",
  //   "#61a5c2",
  //   "#468faf",
  //   "#2c7da0",
  //   "#2a6f97",
  //   "#014f86",
  // ],


  colorUsers: [
    "#DCECFF",
    "#435CCF",
    "#6389DE",
    "#7A96CA",
    "#D18FFF",
    "#833DC9",
    "#FECBD1",
    "#3F8EC9",
  ],

  colorAvatars: ['#00AA55', '#009FD4', '#B381B3', '#939393', '#E3BC00', '#D47500', '#DC2A2A'],

  colorPalette: [
    "#c9e4de",
    "#c6def1",
    "#faedcb",
    "#dbcdf0",
    "#f7d9c4",
    "#f2c6de",
    "#3f8ec9",
    "#48b0a8",
    "#4ee0b5",
    "#b0a3a8",
    "#b3b7fa",
    "#c7ecfc",
    "#bef7f2",
    "#d5f5a7",
    "#ffef99",
    "#fee5bc",
    "#fecbd1",
  ],

  colorTags: [
    "#f94144",
    "#f8961e",
    "#277da1",
    "#43aa8b",
    "#d5f5a7",
    "#f3722c",
    "#ffef99",
    "#fee5bc",
    "#f9844a",
    "#fecbd1",
    "#c9e4de",
    "#c6def1",
    "#faedcb",
    "#dbcdf0",
    "#f7d9c4",
    "#f2c6de",
    "#3f8ec9",
  ],

  colorSelections: [
    "#014F86",
    "#2A6F97",
    "#2C7DA0"
  ],

  colorKanban: [
    "#C1E4DD",
    "#BEDEF2",
    "#F7EBDC",
    "#E3E6DE",
    "#EBE4F4",
    "#F1EBE2",
    "#3f8ec9",
    "#48b0a8",
    "#4ee0b5",
    "#b0a3a8",
    "#b3b7fa",
    "#c7ecfc",
    "#bef7f2",
    "#d5f5a7",
    "#ffef99",
    "#fee5bc",
    "#fecbd1",
  ]

};
